var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (admin, badges, comment, official, premier) {
      badges = comment.user.badges || []
admin = badges.includes("admin")
official = badges.includes("official")
premier = badges.includes("premier")
pug_html = pug_html + "\u003Cdiv" + (" class=\"livestreaming-discussion-item\""+pug.attr("data-id", comment.id, true, true)) + "\u003E\u003Ca" + (" class=\"livestreaming-discussion-item__avatar\""+pug.attr("data-id", comment.user.id, true, true)+pug.attr("href", comment.user.links.self, true, true)) + "\u003E";
if (comment.user.default_avatar && comment.user.initial !== '0') {
pug_html = pug_html + "\u003Cdiv class=\"livestreaming-discussion-item__initial avatar-initial\"\u003E" + (pug.escape(null == (pug_interp = comment.user.initial.charAt(0)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (" class=\"livestreaming-discussion-item__avatar-image\""+pug.attr("src", comment.user.avatar_url_small, true, true)) + "\u003E";
}
if (premier) {
pug_html = pug_html + "\u003Cdiv class=\"livestreaming-discussion-item__avatar-premier-badge\"\u003E&nbsp;\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fa\u003E\u003Cdiv class=\"livestreaming-discussion-item__body\"\u003E\u003Cspan" + (" class=\"livestreaming-discussion-item__timestamp\""+pug.attr("title", comment.created_at, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"livestreaming-discussion-item__header\"\u003E\u003Ca" + (" class=\"livestreaming-discussion-item__username\""+pug.attr("data-id", comment.user.id, true, true)+pug.attr("href", comment.user.links.self, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = comment.user.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (admin) {
pug_html = pug_html + "\u003Cspan class=\"livestreaming-discussion-item__admin-badge\"\u003E" + (pug.escape(null == (pug_interp = 'Admin') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else
if (official) {
pug_html = pug_html + "\u003Cspan class=\"livestreaming-discussion-item__official-badge css-tooltip\"\u003E\u003Cdiv class=\"css-tooltip__text css-tooltip__text-right\"\u003EOfficial\u003C\u002Fdiv\u003E&nbsp;\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003Cspan class=\"livestreaming-discussion-item__content imojify js-component\" data-component=\"Stickerify\"\u003E" + (pug.escape(null == (pug_interp = comment.content) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "admin" in locals_for_with ?
        locals_for_with.admin :
        typeof admin !== 'undefined' ? admin : undefined, "badges" in locals_for_with ?
        locals_for_with.badges :
        typeof badges !== 'undefined' ? badges : undefined, "comment" in locals_for_with ?
        locals_for_with.comment :
        typeof comment !== 'undefined' ? comment : undefined, "official" in locals_for_with ?
        locals_for_with.official :
        typeof official !== 'undefined' ? official : undefined, "premier" in locals_for_with ?
        locals_for_with.premier :
        typeof premier !== 'undefined' ? premier : undefined));
    ;;return pug_html;};
module.exports = template;